<style scoped>
@media (max-width: 992px) {
  .contributor-row {
    text-align: center;
  }
}

.center-align {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.contributor-row {
  min-height: 80px;
  align-items: center;
  padding: 9px 0 0 0;
  margin: 2px;
}
.contributor-row >>> svg {
  cursor: pointer;
}
.invite-status > span {
  padding: 6px;
  margin-top: 10px;
  border-radius: 0.25rem;
}
</style>
<template>
  <b-row class="contributor-row">
    <b-col lg="9">
      <b-row>
        <b-col col-1 lg="2">
          <div class="center-align">
            <b-img
              width="63px"
              :src="profilePicture"
            />
          </div>
        </b-col>
        <b-col col-1 lg="6">
          <div class="center-align">
            {{ (owner && owner.borrower_name) || '-' }}
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col lg="2" class="mt-2" >
      <b-button
        size="sm"
        icon="trash"
        color="#6c757d"
        class="btn-anchor"
        @click="$emit('enter-click')"
      >
        Enter
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    owner: Object,
    profilePicture: {
      type: String,
      default: './static/profile/profile.svg',
    },
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/teams_area/MainAccountCard.vue